import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Eye, EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { login, formatError } from "@/lib/api";
import { toast } from "sonner";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_20601db6-8b59-495a-899a-ce4625f47158/artifacts/u4f6xq9k_image.png";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await login({ email, password });
      localStorage.setItem("admin_token", res.data.token);
      toast.success("Bienvenido al panel de administración");
      navigate("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    }
    setLoading(false);
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen bg-zinc-950 flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm"
      >
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Construtop" className="h-10 mx-auto mb-6" />
          <h1 className="font-heading text-2xl text-white">Panel de Administración</h1>
          <p className="text-zinc-500 text-sm mt-2">Ingrese sus credenciales para continuar</p>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 p-8">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label className="text-zinc-400">Email</Label>
              <Input
                data-testid="admin-email-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="admin@construtop.com"
                className="rounded-none mt-1.5 bg-zinc-800 border-zinc-700 text-white"
                required
              />
            </div>
            <div>
              <Label className="text-zinc-400">Contraseña</Label>
              <div className="relative mt-1.5">
                <Input
                  data-testid="admin-password-input"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Su contraseña"
                  className="rounded-none bg-zinc-800 border-zinc-700 text-white pr-10"
                  required
                />
                <button
                  type="button"
                  data-testid="toggle-password-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-300 transition-colors"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
            <Button
              data-testid="admin-login-btn"
              type="submit"
              disabled={loading}
              className="w-full bg-emerald-600 hover:bg-emerald-700 text-white rounded-none font-bold tracking-wide"
            >
              <Lock size={16} className="mr-2" />
              {loading ? "INGRESANDO..." : "INGRESAR"}
            </Button>
          </form>
        </div>

        <p className="text-center mt-6">
          <a href="/" className="text-zinc-500 text-sm hover:text-emerald-400 transition-colors">Volver al sitio</a>
        </p>
      </motion.div>
    </main>
  );
}
